import React from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import AMPPage from '../AMPPage';
import AMPPageHeader from '../AMPPageHeader';
import AMPPageSection from '../AMPPageSection';
import AMPPodcastReadySection from '../AMPPodcastReadySection';
import Img from '../Img';
import OutboundLink from '../OutboundLink';
import styles from './styles.sass';

const METADATA = {
  TITLE: 'About',
};

const IMG_PREFIX = 'https://d12xoj7p9moygp.cloudfront.net/images/';

const AMPAboutPage = props => (
  <AMPPage>
    <AMPPageHeader
      title="About Anchor"
      subtitle="Anchor is the easiest way to make a podcast, ever."
    />
    <AMPPageSection id="Who-We-Are" color="gray">
      <span className={styles.description}>
        Our mission is to democratize audio. We believe everyone should be able
        to have their voice heard, regardless of background or experience level.
        If you've ever tried to start a podcast, you know all the logistical
        barriers that can stand in your way. At Anchor, we aim to remove all of
        these barriers. Our goal is to make podcasting easy and fun, without
        sacrificing the quality every podcaster deserves.
      </span>
      <br />
      <br />
      <span className={styles.description}>
        Want to work with us?{` `}
        <OutboundLink newWindow to="/jobs">
          Check out our open jobs!
        </OutboundLink>
      </span>
    </AMPPageSection>
    <AMPPageSection id="how">
      <Row className={`${styles.infoRow}`}>
        <Col xs={12} sm={8}>
          <h2>How we do it</h2>
          <h3>Creators first.</h3>
          <p>
            Everything we do, we do it for podcasters. Whether you’re a seasoned
            pro or just starting your podcasting journey, Anchor was built to
            solve the pain points around podcasting, while remaining powerful
            enough to make your wildest podcasting dreams come true.
          </p>
          <h3>Tools that are really, really easy to use.</h3>
          <p>
            We’ve reimagined podcasting from the ground up. Every feature in
            Anchor is designed to be so straightforward that anyone (even people
            with zero podcasting experience) can pick it up and start using it
            right away.
          </p>
          <h3>Powerful technology that solves real problems.</h3>
          <p>
            We build intelligent tools that minimize the grunt work, and help
            you navigate podcasting best practices so you can focus on making
            something amazing. Whether it’s recording, editing, or getting
            listeners, we want you to feel like nothing is standing in the way
            of you telling your story.
          </p>
        </Col>
        <Col xs={12} sm={4}>
          <Img
            alt="How we do it"
            src={`${IMG_PREFIX}about-how.png`}
            layout="fixed"
            withRetina
            width={230}
            height={446}
          />
        </Col>
      </Row>
    </AMPPageSection>
    <AMPPageSection color="blue" id="history" className={styles.aboutStory}>
      <div className={styles.polaroids}>
        <Img
          alt="Podcast Creation"
          src={`${IMG_PREFIX}about-anchor-polaroids.png`}
          withRetina
          width={550}
          height={692}
          layout="fixed"
        />
      </div>
      <div className={styles.smallPolaroidTop}>
        <Img
          alt="Podcast Creation"
          src={`${IMG_PREFIX}about-polaroids-top.png`}
          withRetina
          width={383}
          height={233}
          layout="fixed"
        />
      </div>
      <Row bsClass={`${styles.aboutRow} row`}>
        <Col xs={12} sm={7}>
          <h2>Our history</h2>
          <p>
            We’ve both always loved radio, podcasts, playing music, and all
            things audio. In 2014, we were inspired to build an Anchor prototype
            after realizing how difficult it was to create and distribute audio.
            Our experiment quickly took on a life of its own, and we launched
            the first public version of Anchor in 2016. We’re now a growing
            team, based in NYC and continuing to invent crazy new ways for
            people to immerse themselves in the world of audio. We all agree
            it’s the most fun job we’ve ever had.
            <br />- Mike & Nir, Anchor co-founders
          </p>
          <small className={styles.investors}>
            Anchor’s investors include Accel, Acequia Capital, Mick Batyske,
            Scott Belsky, Betaworks, The Chernin Group, CrunchFund, Eniac
            Ventures, Nir Eyal, GV, Homebrew, Craig Kallman, Avi Muchnick,
            Omidyar Network, SV Angel, Questlove, Vijay Vachani, and some our
            closest friends and family members. We wouldn’t be here without
            their support. 🙏
          </small>
        </Col>
      </Row>
      <div className={styles.smallPolaroidBottom}>
        <Img
          alt="Podcast Creation"
          src={`${IMG_PREFIX}about-polaroids-bottom.png`}
          withRetina
          width={398}
          height={246}
          layout="fixed"
        />
      </div>
    </AMPPageSection>
    <AMPPageSection id="contact">
      <Row>
        <Col xs={12} sm={7}>
          <h2>Contact Anchor</h2>
          <p>
            Want to work with us? Get in touch at{' '}
            <a href="mailto:hello@anchor.fm">hello@anchor.fm</a>
          </p>
          <p>
            Got a question about Anchor? Visit us at{' '}
            <a href="https://help.anchor.fm">help.anchor.fm</a>
          </p>
          <p>
            Writing a story?{' '}
            <OutboundLink
              newWindow
              to="https://www.dropbox.com/sh/s1jephnyq9l98hi/AACQZWmeP2no7CbBCivLX6Loa?dl=0"
            >
              Download our press kit
            </OutboundLink>{' '}
            or email us at <a href="mailto:press@anchor.fm">press@anchor.fm</a>
          </p>
        </Col>
      </Row>
    </AMPPageSection>
    <AMPPodcastReadySection />
  </AMPPage>
);

export { AMPAboutPage as default, METADATA };
